/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Task_Reminder_BodyInputs */

const en_notifications_task_reminder_body = /** @type {(inputs: Notifications_Task_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A scheduled reminder for this task is due.`)
};

const pt_br2_notifications_task_reminder_body = /** @type {(inputs: Notifications_Task_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chegou a data de um lembrete agendado para esta atividade.`)
};

/**
* | output |
* | --- |
* | "A scheduled reminder for this task is due." |
*
* @param {Notifications_Task_Reminder_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_reminder_body = /** @type {((inputs?: Notifications_Task_Reminder_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Reminder_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_reminder_body(inputs)
	return pt_br2_notifications_task_reminder_body(inputs)
});